import axios from 'axios'
import {
  AuthorizationResponse,
  GetGithubRepoContentsOptions,
  GitHubContentResponse,
} from './types'
import {
  githubApiUrl,
  swarmOwnerName,
  openOtcRepoName,
  pathToAuthorizations,
} from './consts'
export const axiosClient = axios.create({
  baseURL: githubApiUrl,
})

export const getGithubRepoContents = async ({
  owner,
  repo,
  path = '',
}: GetGithubRepoContentsOptions): Promise<GitHubContentResponse[]> => {
  const response = await axiosClient.get<GitHubContentResponse[]>(
    `repos/${owner}/${repo}/contents/${path}`
  )

  return response.data
}

export const getAuthorizations = async (): Promise<AuthorizationResponse[]> => {
  const authorizationsResponse = await getGithubRepoContents({
    owner: swarmOwnerName,
    repo: openOtcRepoName,
    path: pathToAuthorizations,
  })

  const authorizations: AuthorizationResponse[] = await Promise.all(
    authorizationsResponse.map(async auth => {
      const { data } = await axios<AuthorizationResponse>(auth.download_url!)

      return data
    })
  )

  return authorizations
}
